export default (state = true, { type, payload }) => {
    switch (type) {
    case 'SHOW_ZOOM_LEVEL':
      return true
    case 'HIDE_ZOOM_LEVEL':
      return false
    default:
      return state
    }
  }